import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FrownTwoToneSvg from "@ant-design/icons-svg/es/asn/FrownTwoTone";
import AntdIcon from "../components/AntdIcon";
var FrownTwoTone = function FrownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FrownTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FrownTwoTone.displayName = 'FrownTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FrownTwoTone);